// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.8.3
//   protoc               v3.21.12
// source: getcase.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { CaseStatus, caseStatusFromJSON, caseStatusToJSON } from "./schema";

export const protobufPackage = "login";

export interface GetCaseRequest {
  caseId: string;
}

export interface GetCaseResponse {
  /** Required. The status of case AI job. */
  status: CaseStatus;
  /** Optional. The markdown of the AI response. */
  markdown: string;
}

function createBaseGetCaseRequest(): GetCaseRequest {
  return { caseId: "" };
}

export const GetCaseRequest: MessageFns<GetCaseRequest> = {
  encode(message: GetCaseRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.caseId !== "") {
      writer.uint32(10).string(message.caseId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCaseRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCaseRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.caseId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCaseRequest {
    return { caseId: isSet(object.caseId) ? globalThis.String(object.caseId) : "" };
  },

  toJSON(message: GetCaseRequest): unknown {
    const obj: any = {};
    if (message.caseId !== "") {
      obj.caseId = message.caseId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCaseRequest>, I>>(base?: I): GetCaseRequest {
    return GetCaseRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCaseRequest>, I>>(object: I): GetCaseRequest {
    const message = createBaseGetCaseRequest();
    message.caseId = object.caseId ?? "";
    return message;
  },
};

function createBaseGetCaseResponse(): GetCaseResponse {
  return { status: 0, markdown: "" };
}

export const GetCaseResponse: MessageFns<GetCaseResponse> = {
  encode(message: GetCaseResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.status !== 0) {
      writer.uint32(8).int32(message.status);
    }
    if (message.markdown !== "") {
      writer.uint32(18).string(message.markdown);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCaseResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCaseResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.markdown = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCaseResponse {
    return {
      status: isSet(object.status) ? caseStatusFromJSON(object.status) : 0,
      markdown: isSet(object.markdown) ? globalThis.String(object.markdown) : "",
    };
  },

  toJSON(message: GetCaseResponse): unknown {
    const obj: any = {};
    if (message.status !== 0) {
      obj.status = caseStatusToJSON(message.status);
    }
    if (message.markdown !== "") {
      obj.markdown = message.markdown;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCaseResponse>, I>>(base?: I): GetCaseResponse {
    return GetCaseResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCaseResponse>, I>>(object: I): GetCaseResponse {
    const message = createBaseGetCaseResponse();
    message.status = object.status ?? 0;
    message.markdown = object.markdown ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
